import './filter-modal.scss';
import { SafeUrl } from '../utils';

/**
 * version    1.0
 * class      <type> (FilterModal)
 * classdesc   FilterModal
 */
export class FilterModal {
  constructor() {
    if (document.getElementById('filter_modal_form')) {
      document.getElementById('filter_modal_form').addEventListener('submit', (e) => {
        const checked = Array.from(document.querySelectorAll('.btn-check:checked')).map((ch) => ch.value);
        document.getElementById('cCsv').value = checked.join(',');
        // action="#": se i filtri non cambiano l'URL di destinazione coincide con quello
        // corrente (frammento compreso) e il browser non ricarica, lasciando aperta la modale.
        // Senza frammento la navigazione avviene sempre.
        e.currentTarget.action = window.location.pathname;
      });

      const params = new URLSearchParams(window.location.search);
      const c = params.get('c');
      if (c) {
        const selected = c.split(',').map((s) => s.trim()).filter(Boolean);
        selected.forEach((code) => {
          const el = document.getElementById(`topic_${code}`);
          if (el) el.checked = true;
        });
        document.getElementById('cCsv').value = selected.join(',');
      }
      const dateFrom = params.get('dateFrom');
      if (dateFrom) {
        const el = document.getElementById('dateFrom');
        if (el) el.value = dateFrom;
      }
      const dateTo = params.get('dateTo');
      if (dateTo) {
        const el = document.getElementById('dateTo');
        if (el) el.value = dateTo;
      }
      const rawPeriod = params.get('period');
      if (rawPeriod) {
        const period = (rawPeriod || 'desc').toLowerCase();
        const el = document.querySelector(`input[name="period"][value="${period === 'asc' ? 'asc' : 'desc'}"]`);
        if (el) el.checked = true;
      }
    }

    document.querySelectorAll('.filters__tag').forEach((btn) => {
      btn.addEventListener('click', () => {
        SafeUrl.navigate(btn.dataset.value);
      });
    });

    const filtersSelect = document.getElementById('filters-select');
    if (filtersSelect) {
      filtersSelect.addEventListener('change', () => {
        SafeUrl.navigate(filtersSelect.value);
      });
    }

    document.querySelectorAll('input[name="sort"], input[name="sortMobile"]').forEach((el) => {
      el.addEventListener('click', () => {
        SafeUrl.navigate(el.dataset.value || el.value);
      });
    });
  }
}
